import React from 'react';
import { Form, Header, Segment } from 'semantic-ui-react';
import axios from 'axios';

import EnrolledStudents from './EnrolledStudents';
import EnrolledWithAverageGrade from './EnrolledWithAverageGrade';
import StudyProgramPerCycle from './StudyProgramPerCycle';
import EnrolledStudentsPerCountries from './EnrolledStudentsPerCountries';
import EnrolledStudentsPerMunicipalities from './EnrolledStudentsPerMunicipalities';
import ConstReports from '../Reports/ConstReports/ConstReports';
import EnrolledStudentsPerGender from './EnrolledStudentsPerGender';
import EnrolledStudentWithNumberOfPassedCourses from './EnrolledStudentWithNumberOfPassedCourses';
import EnrolledStudentAverageGradeAndPassedCourses from './EnrolledStudentAverageGradeAndPassedCourses';
import PreviousSemesterStudents from './PreviousSemesterStudents';
import WithdrawalStudents from './WithdrawalStudents';
import GradStudents from './GradStudents';
import LockedGraduatedStudents from './LockedGraduatedStudents';
import WorkloadReport from '../../HR/WorkloadReport';
import EmployeesByType from '../../HR/EmployeesByType';
import EmployeesByAcademicTytle from '../../HR/EmployeesByAcademicTytle';
import EmployeesByTypeAndGender from '../../HR/EmployeesByTypeAndGender';
import EmployeesByTypeAndPosition from '../../HR/EmployeesByTypeAndPosition';
import EmployeesByTypePositionAndAverageYear from '../../HR/EmployeesByTypePositionAndAverageYear';
import AssociateEmployeesByTypeAndPosition from '../../HR/AssociateEmployeesByTypeAndPosition';
import EmployeesWithOUEInfo from '../../HR/EmployeesWithOUEInfo';
import EmployeesWithOUPositionInfo from '../../HR/EmployeesWithOUPositionInfo';
import { fetchAcademicYears, fetchEmployeeTypes, fetchFaculties } from '../../Lookups/util';
import EnrolledStudentsPerCountriesAllData from './EnrolledStudentsPerCountriesAllData';
import EnrolledStudentsPerGenderAllData from './EnrolledStudentsPerGenderAllData';
import EnrolledStudentsPerMunicipalitiesAllData from './EnrolledStudentPerMunicipalitiesAllData';
import StudentsWithDisciplinaryProcedure from './StudentsWithDisciplinaryProcedure';
import StudentsWithPause from './StudentsWithPause';
import EnrolledStudentsWithCourses from './EnrolledStudentsWithCourses';
import CoursesByCycle from './CoursesPerCycle';
import StudentsByCycle from './StudentsPerCycle';
import EmployeesByStudyProgramBasic from './EmployeesByStudyProgramBasic';
import EmployeesGenderAndAgeByPosition from '../../HR/EmployeesGenderAndAgeByPosition';
import EmployeesGenderAndAgeByEducationLevel from '../../HR/EmployeesGenderAndAgeByEducationLevel';
import EmployeesByTypeAndAcademicYear from '../../HR/EmployeesByTypeAndAcademicYear';
import EnrolledStudentsPerCourses from './EnrolledStudentsPerCourses';
import EnrolledStudentsPerStudyYearAndStudyTypeForFaculty from './EnrolledStudentsPerStudyYearAndStudyTypeForFaculty';
import GradStudentsPerStudyYearAndStudyTypeForFaculty from './GradStudentsPerStudyYearAndStudyTypeForFaculty';
import StudyProgramsByStudyCyclesForFaculty from './StudyProgramsByStudyCyclesForFaculty';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


class StudentsReports extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            report: localStorage.getItem('report') ? parseInt(localStorage.getItem('report')) : null,
            organizationalUnits: [],
            employeeTypes: [],
            academicYears: [],
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.closeReport = this.closeReport.bind(this);
    }

    componentDidMount() {
        axios.all([fetchFaculties(), fetchAcademicYears(), fetchEmployeeTypes()])
            .then(axios.spread((orgUnitsRes, academicYearsRes, employeeTypesRes) => {
                const organizationalUnits = orgUnitsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                })).filter(el => el.text !== 'Akademija likovnih umjetnosti i Prirodno-matematički fakultet' && el.text !== 'Testni fakultet');

                const academicYears = academicYearsRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                })).reverse();

                const employeeTypes = employeeTypesRes.data.map(el => ({
                    ...el, text: el.name, value: el.id, key: el.id
                }));

                this.setState({
                    employeeTypes, organizationalUnits, academicYears, employeeTypeId: employeeTypesRes.data.find(e => e._key === 'nastavno osoblje').id
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch org. units');
            });
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
        localStorage.setItem('report', value);
    }

    closeReport() {
        this.setState({ report: null });
        localStorage.removeItem('report');
    }

    render() {
        const activeRole = localStorage.getItem('activeRole');
        const vicedean = activeRole && activeRole.substr(0, 19) === 'Prodekan za nastavu';
        const unsa = activeRole && activeRole.substr(0, 38) === 'Služba za nastavu i studentska pitanja';
        const quality = activeRole && activeRole.substr(0, 30) === 'Služba za osiguranje kvaliteta';
        const aida = activeRole && activeRole.substr(0, 38) === 'AIDA';
        const admin = activeRole && activeRole.substr(0, 13) === 'Administrator';

        const reports = [
            {
                key: 0,
                value: 0,
                text: 'Upisani studenti'
            },
            !unsa && !aida && !admin && !quality && {
                key: 1,
                value: 1,
                text: 'Upisani studenti sa prosjekom'
            },
            {
                key: 2,
                value: 2,
                text: 'Broj upisanih studenata po državljanstvu'
            },
            !unsa && !aida && !admin && !quality && {
                key: 23,
                value: 23,
                text: 'Upisani studenti po državljanstvu'
            },
            {
                key: 3,
                value: 3,
                text: 'Broj upisanih studenata po općini prebivališta'
            },
            !unsa && !aida && !admin && !quality && {
                key: 25,
                value: 25,
                text: 'Upisani studenti po općini prebivališta'
            },
            {
                key: 4,
                value: 4,
                text: 'Broj upisanih studenata po spolu'
            },
            !unsa && !aida && !admin && !quality && {
                key: 24,
                value: 24,
                text: 'Upisani studenti po spolu'
            },
            !unsa && !aida && !admin && !quality && {
                key: 5,
                value: 5,
                text: 'Upisani studenti sa brojem položenih predmeta iz prethodne studijske godine u prethodnoj akademskoj godini'
            },
            !unsa && !aida && !admin && !quality && {
                key: 6,
                value: 6,
                text: 'Upisani studenti sa trenutnim prosjekom i sa brojem položenih predmeta iz prethodne studijske godine u prethodnoj akademskoj godini '
            },
            {
                key: 7,
                value: 7,
                text: 'Ispisani studenti'
            },
            {
                key: 8,
                value: 8,
                text: 'Apsolventi'
            },
            !unsa && !aida && !admin && !quality && {
                key: 22,
                value: 22,
                text: 'Studenti koji nisu upisani u trenutni semestar'
            },
            {
                key: 9,
                value: 9,
                text: 'Diplomirani / zaključani studenti'
            },
            {
                key: 10,
                value: 10,
                text: 'Prolaznost na predmetima'
            },
            {
                key: 11,
                value: 11,
                text: 'Broj studijskih programa po ciklusu'
            },
            !unsa && !aida && !admin && !quality && {
                key: 26,
                value: 26,
                text: 'Studenti sa disciplinskim mjerama'
            },
            !unsa && !aida && !admin && !quality && {
                key: 27,
                value: 27,
                text: 'Studenti sa statusom mirovanja'
            },
            !unsa && !aida && !admin && !quality && {
                key: 28,
                value: 28,
                text: 'Studenti sa predmetima koje slušaju'
            },

            {
                key: 29,
                value: 29,
                text: 'Ukupan broj predmeta po ciklusu'
            },

            {
                key: 30,
                value: 30,
                text: 'Ukupan broj studenata po ciklusu'
            },

            quality && {
                key: 31,
                value: 31,
                text: 'Ukupan broj zaposlenika i spoljnih saradnika po studijskom programu'
            },

            vicedean && {
                text: 'Nastavno opterećenje nastavnika/saradnika',
                key: 12,
                value: 12
            },
            //     quality && {
            //     text: 'Nastavno opterećenje za organizacionu jedinicu',
            //     key: 13,
            //     value: 13
            // },
            quality && {
                text: 'Broj zaposlenika po tipu zaposlenja',
                key: 14,
                value: 14
            },
            quality && {
                text: 'Broj zaposlenika po akademskoj tituli',
                key: 15,
                value: 15
            },
            quality && {
                text: 'Broj zaposlenika po spolu (po tipu zaposlenja)',
                key: 16,
                value: 16
            },
            quality && {
                text: 'Broj zaposlenika po pozicijama (po tipu zaposlenja)',
                key: 17,
                value: 17
            },
            quality && {
                text: 'Prosjek godina po pozicijama',
                key: 18,
                value: 18
            },
            quality && {
                text: 'Broj angažovanog osoblja po pozicijama',
                key: 19,
                value: 19
            },
            // quality && {
            //     text: 'Podaci o zaposlenicima sa njihovim angažmanima na organizacionim jedinicama',
            //     key: 20,
            //     value: 20
            // },
            // quality && {
            //     text: 'Podaci o zaposlenicima sa njihovim pozicijama na matičnoj organizacionoj jedinici',
            //     key: 21,
            //     value: 21
            // },

            quality && {
                text: 'Starosna i spolna struktura nastavnika i saradnika u radnom odnosu',
                key: 32,
                value: 32
            },
            quality && {
                text: 'Kadrovska, starosna i spolna struktura stalno zaposlenog nenastavnog osoblja',
                key: 33,
                value: 33
            },
            quality && {
                text: 'Broj zaposlenika u stalnom i dopunskom radnom odnosu po tipu i akademskoj godini',
                key: 34,
                value: 34
            },
            !unsa && !aida && !admin && !quality && {
                text: 'Spisak upisanih studenata po predmetu',
                key: 35,
                value: 35
            },
            (admin || aida || unsa) && {
                text: "Broj upisanih studenata po godinama i statusu",
                key: 36,
                value: 36
            },
            (admin || aida || unsa) && {
                text: "Broj apsolvenata po godinama i statusu",
                key: 37,
                value: 37
            },
            (admin || aida) && {
                text: "Studijski programi po ciklusima",
                key: 38,
                value: 38
            }
        ].filter(Boolean);

        const { report } = this.state;
        return (
            <div>
                <Header as="h1">Izvještaji</Header>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3"> Spisak izvještaja
                        </Header>
                    </Segment>
                    <Segment secondary={report !== null}>
                        <Header as="h3">
                            <Form noValidate>
                                <Form.Dropdown
                                    clearable
                                    placeholder="Odaberite izvještaj"
                                    value={report}
                                    onChange={this.handleInputChange}
                                    name="report"
                                    options={reports}
                                    search
                                    fluid
                                    selection
                                />
                            </Form>
                        </Header>
                    </Segment>


                    {localStorage.getItem('report') === '0' &&
                        <Segment clearing>
                            <EnrolledStudents organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '35' &&
                        <Segment clearing>
                            <EnrolledStudentsPerCourses organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '1' &&
                        <Segment clearing>
                            <EnrolledWithAverageGrade organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '2' &&
                        <Segment clearing>
                            <EnrolledStudentsPerCountries organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '3' &&
                        <Segment clearing>
                            <EnrolledStudentsPerMunicipalities organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '4' &&
                        <Segment clearing>
                            <EnrolledStudentsPerGender organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '5' &&
                        <Segment clearing>
                            <EnrolledStudentWithNumberOfPassedCourses organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '6' &&
                        <Segment clearing>
                            <EnrolledStudentAverageGradeAndPassedCourses organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '7' &&
                        <Segment clearing>
                            <WithdrawalStudents organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '8' &&
                        <Segment clearing>
                            <GradStudents organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '9' &&
                        <Segment clearing>
                            <LockedGraduatedStudents organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '10' &&
                        <Segment clearing>
                            <ConstReports organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '11' &&
                        <Segment clearing>
                            <StudyProgramPerCycle organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '23' &&
                        <Segment clearing>
                            <EnrolledStudentsPerCountriesAllData organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '24' &&
                        <Segment clearing>
                            <EnrolledStudentsPerGenderAllData organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '25' &&
                        <Segment clearing>
                            <EnrolledStudentsPerMunicipalitiesAllData organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '26' &&
                        <Segment clearing>
                            <StudentsWithDisciplinaryProcedure organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '27' &&
                        <Segment clearing>
                            <StudentsWithPause organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '28' &&
                        <Segment clearing>
                            <EnrolledStudentsWithCourses organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '29' &&
                        <Segment clearing>
                            <CoursesByCycle organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '30' &&
                        <Segment clearing>
                            <StudentsByCycle organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '31' &&
                        <Segment clearing>
                            <EmployeesByStudyProgramBasic organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}

                    {localStorage.getItem('report') === '36' &&
                        <Segment clearing>
                            <EnrolledStudentsPerStudyYearAndStudyTypeForFaculty organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>}
                    {localStorage.getItem('report') === '37' &&
                        <Segment clearing>
                            < GradStudentsPerStudyYearAndStudyTypeForFaculty organizationalUnits={this.state.organizationalUnits} closeReport={this.closeReport} />
                        </Segment>
                    }
                    {localStorage.getItem('report') === '38' &&
                        <Segment clearing>
                            <StudyProgramsByStudyCyclesForFaculty 
                                organizationalUnits={this.state.organizationalUnits} 
                                academicYears={this.state.academicYears}
                                closeReport={this.closeReport}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '12' &&
                        <Segment clearing>
                            <WorkloadReport
                                closeReport={this.closeReport}
                                academicYears={this.state.academicYears}
                                employees
                                employeeTypeId={this.state.employeeTypeId}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '13' &&
                        <Segment clearing>
                            <WorkloadReport
                                closeReport={this.closeReport}
                                academicYears={this.state.academicYears}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '14' &&
                        <Segment clearing>
                            <EmployeesByType
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '15' &&
                        <Segment clearing>
                            <EmployeesByAcademicTytle
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                            />
                        </Segment>}


                    {localStorage.getItem('report') === '16' &&
                        <Segment clearing>
                            <EmployeesByTypeAndGender
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '17' &&
                        <Segment clearing>
                            <EmployeesByTypeAndPosition
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '18' &&
                        <Segment clearing>
                            <EmployeesByTypePositionAndAverageYear
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '19' &&
                        <Segment clearing>
                            <AssociateEmployeesByTypeAndPosition
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}


                    {localStorage.getItem('report') === '20' &&
                        <Segment clearing>
                            <EmployeesWithOUEInfo
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '21' &&
                        <Segment clearing>
                            <EmployeesWithOUPositionInfo
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '22' &&
                        <Segment clearing>
                            <PreviousSemesterStudents
                                closeReport={this.closeReport}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '32' &&
                        <Segment clearing>
                            <EmployeesGenderAndAgeByPosition
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '33' &&
                        <Segment clearing>
                            <EmployeesGenderAndAgeByEducationLevel
                                closeReport={this.closeReport}
                                organizationalUnits={this.state.organizationalUnits}
                                employeeTypes={this.state.employeeTypes}
                            />
                        </Segment>}

                    {localStorage.getItem('report') === '34' &&
                        <Segment clearing>
                            <EmployeesByTypeAndAcademicYear
                                closeReport={this.closeReport}
                                academicYears={this.state.academicYears}
                                employeeTypes={this.state.employeeTypes}
                                organizationalUnits={this.state.organizationalUnits}
                            />
                        </Segment>}

                </Segment.Group>

            </div>
        );
    }
}

export default StudentsReports;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentsReports/StudentsReports.js